import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { SiaCssEditorComponent, SiaJsEditorComponent } from '@sia/code-editor';
import {
  SiaCheckBoxComponent,
  SiaColorBoxComponent,
  SiaNumberboxComponent,
  SiaSelectBoxComponent,
  SiaTextBoxComponent,
} from '@sia/inputs';
import {
  SafeHtmlPipe,
  SiaAccordionComponent,
  SiaSqlFilters,
  SiaTranslatePipe,
} from '@sia/shared';
import { SiaGridColConfig } from '../../interfaces/sia-grid-col-config';

@Component({
  selector: 'sia-mat-grid-configurator-column',
  templateUrl: './sia-mat-grid-configurator-column.component.html',
  styleUrls: ['./sia-mat-grid-configurator-column.component.scss'],
  standalone: true,
  imports: [
    SiaAccordionComponent,
    SiaCheckBoxComponent,
    SiaTextBoxComponent,
    SiaSelectBoxComponent,
    SiaJsEditorComponent,
    MatFormField,
    MatLabel,
    MatSelect,
    MatSelectTrigger,
    MatOption,
    SiaNumberboxComponent,
    MatIcon,
    SiaCssEditorComponent,
    SiaTranslatePipe,
    SafeHtmlPipe,
    SiaColorBoxComponent,
    MatButton,
  ],
})
export class SiaMatGridConfiguratorColumnComponent {
  private _timeouts: any[] = [];
  @Input() column: SiaGridColConfig = {};
  @Input() dataBaseFields: { id: string; description: string }[] = [];
  fieldSummaryColumnMessage: Map<string, string> = new Map<string, string>([
    ['empty', 'Se vuoto verrà usato il campo principale'],
  ]);
  sqlFilters = new SiaSqlFilters();
  gridConfSortOrderTypes: any[] = [
    { id: '', description: 'Nessuno' },
    { id: 'asc', description: 'Asc' },
    { id: 'desc', description: 'Desc' },
  ];
  gridConfAlignmentTypes: any[] = [
    { id: 'center', description: 'Cn' },
    { id: 'left', description: 'Sx' },
    { id: 'right', description: 'Dx' },
  ];
  summaryTypes: any[] = [
    { id: '', description: 'Nessuno' },
    { id: 'sum', description: 'Somma' },
    { id: 'count', description: 'Count' },
    { id: 'min', description: 'Minimo' },
    { id: 'max', description: 'Massimo' },
    { id: 'avg', description: 'Media' },
  ];
  gridConfFormatTypes: any[] = [
    { id: '', description: 'Nessuno' },
    { id: 'string', description: 'Stringa' },
    { id: 'number', description: 'Numero' },
    { id: 'object', description: 'Oggetto' },
    { id: 'date', description: 'Data' },
    { id: 'datetime', description: 'Data e tempo' },
    { id: 'boolean', description: 'Booleano' },
    { id: 'image', description: 'Immagine' },
    { id: 'svg', description: 'Svg' },
    { id: 'icon', description: 'Icona' },
    { id: 'avatar', description: 'Avatar' },
    { id: 'color', description: 'Colore' },
  ];
  gridConfImageSourceTypes: any[] = [
    { id: 'url', description: 'Url' },
    { id: 'path', description: 'Percorso' },
  ];
  gridConfContrastModeTypes: any[] = [
    { id: 'auto', description: 'Auto' },
    { id: 'shade', description: 'Shade' },
    { id: 'tint', description: 'Tint' },
    { id: 'adaptive', description: 'Adaptive' },
  ];
  cssAreas: any[] = [
    { id: '', description: 'Nessuno' },
    { id: 'row', description: 'Riga' },
    { id: 'cell', description: 'Cella' },
  ];

  getFiltersByType(type: string) {
    switch (type.toLowerCase()) {
      case 'string':
        return [
          ...this.sqlFilters.stringFilters,
          ...this.sqlFilters.additionalFilters,
        ];
      case 'number':
        return [
          ...this.sqlFilters.numberFilters,
          ...this.sqlFilters.additionalFilters,
        ];
      case 'date':
      case 'time':
      case 'datetime':
        return this.sqlFilters.dateFilters;
      default:
        return this.sqlFilters.allFilters;
    }
  }

  getFilterHtml(filterId?: string) {
    if (!filterId) {
      return '';
    }
    return this.sqlFilters.allFilters.find((x) => x.id == filterId)
      ?.htmlContent;
  }

  addPrefilter() {
    this.column.prefilters = this.column.prefilters ?? [];
    this.column.prefilters.unshift({});
  }
  removePrefilter(filterIndex: number) {
    this.column.prefilters?.splice(filterIndex, 1);
  }
  addFormat() {
    this.column.excelConfiguration!.formatting =
      this.column.excelConfiguration!.formatting ?? [];
    this.column.excelConfiguration!.formatting.push({});
  }
  removeFormat(filterIndex: number) {
    this.column.excelConfiguration!.formatting?.splice(filterIndex, 1);
  }
  addStyle() {
    this.column.styleConditions = this.column.styleConditions ?? [];
    this.column.styleConditions.unshift({});
  }
  removeStyle(filterIndex: number) {
    this.column.styleConditions?.splice(filterIndex, 1);
  }
  isActionChange() {
    let t = setTimeout(() => {
      // console.log(this.column.isAction);
      if (this.column.isAction) {
        this.column.dataType = 'action';
      }
    }, 0);
    this._timeouts.push(t);
  }

  onDataFieldChange($event: SiaGridColConfig) {
    $event.dataField = $event.dataField?.toLowerCase();
  }

  ngOnDestroy() {
    this._timeouts?.forEach((t) => {
      clearTimeout(t);
    });
    this._timeouts = [];
    this.column = {} as SiaGridColConfig;
  }
}
